import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { PaymentStatus, PaymentType } from "@/api-v3";

const STATUS_PARAM = "status";
const TYPE_PARAM = "type";

const STATUS_VALUES = new Set<string>(Object.values(PaymentStatus));
const TYPE_VALUES = new Set<string>(Object.values(PaymentType));

export function usePaymentFilters() {
  const [searchParams, setSearchParams] = useSearchParams();

  const status = useMemo(() => {
    return searchParams
      .getAll(STATUS_PARAM)
      .filter((value): value is PaymentStatus => STATUS_VALUES.has(value));
  }, [searchParams]);

  const types = useMemo(() => {
    return searchParams
      .getAll(TYPE_PARAM)
      .filter((value): value is PaymentType => TYPE_VALUES.has(value));
  }, [searchParams]);

  const setStatus = useCallback(
    (next: PaymentStatus[]) => {
      setSearchParams(
        (prev) => {
          const updated = new URLSearchParams(prev);
          updated.delete(STATUS_PARAM);
          next.forEach((value) => updated.append(STATUS_PARAM, value));
          return updated;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  const setTypes = useCallback(
    (next: PaymentType[]) => {
      setSearchParams(
        (prev) => {
          const updated = new URLSearchParams(prev);
          updated.delete(TYPE_PARAM);
          next.forEach((value) => updated.append(TYPE_PARAM, value));
          return updated;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return { status, types, setStatus, setTypes };
}
